export function formatCurrency(amountFrom, amountTo, rateType, currency) {
	if (!amountFrom || !amountTo || !rateType || !currency) {
		return '';
	}

	const formattedRateType = rateType ? `/${rateType}` : '';

	const currencySymbols = {
		USD: '$',
		PHP: '₱',
		CAD: 'CA$',
		AUD: 'A$',
		NZD: 'NZ$',
	};

	const symbol = currencySymbols[currency];
	const range = amountFrom !== amountTo ? `${amountFrom} - ${amountTo}` : amountFrom;

	if (symbol) {
		return (
			<>
				<span className="opacity-70">{symbol}</span>
				{range}
				{formattedRateType} <span className="text-xs opacity-70">({currency})</span>
			</>
		);
	}

	return (
		<>
			{range}
			{formattedRateType} <span className="text-xs opacity-70">({currency})</span>
		</>
	);
}
